module.exports = __webpack_public_path__ + "img/tool-time.38e2b57.webp";